import { render, staticRenderFns } from "./TestDrivePointDetail.vue?vue&type=template&id=27cf1166&"
import script from "./TestDrivePointDetail.vue?vue&type=script&lang=js&"
export * from "./TestDrivePointDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports